// import axios from 'axios';
import { del, get, post, put } from './api_helper';
import * as url from './url_helper';

export const fetchPrivateData = () => get(url.CHECK_AUTH);
// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem('user');
  if (user) return JSON.parse(user);
  return null;
};
//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};
// Login Method
const postLogin = (data) => post(url.POST_LOGIN, data);
const postJwtForgetPwd = (data) => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
const postJwtResetPwd = (data) => put(url.POST_FAKE_JWT_PASSWORD_RESET + `/${data.resetToken}`, data);
//Profile
export const updatePhoto = (employee) => put(url.EDIT_PHOTO + `/${employee._id}`, employee);
export const updateUserData = (user) => put(url.UPDATE_USER_DATA + `/${user._id}`, user);
export const updateMode = (user) => put(url.UPDATE_MODE + `/${user._id}`, user);
export const updatePassword = (employee) => put(url.EDIT_PASSWORD + `/${employee._id}`, employee);
//DASHBOARD
export const getDashboardInfo = (id) => get(url.GET_DASHBOARD_INFO + `/${id}`);
export const getDashboardInfoFilter = (data) => post(url.GET_DASHBOARD_INFO_FILTER, data);
export const calculateMedianAverage = (id) => post(url.GET_MEDIAN_AVERAGE, id);
//BATTLEFIELD
// get battles with specific range
export const getBattlefieldInfo = (battle) => put(url.GET_BATTLE_INFO + `/${battle._id}`, battle);
export const getSpecBattle = (battle) => post(url.GET_SPEC_BATTLE, battle);
//PRIORITY
export const getPriorityInfo = () => get(url.GET_PRIORITY_INFO);
// get archive 50 orders each time page clicked
export const getArchive = (prioirity) => post(url.GET_ARCHIVE_PR, prioirity);
export const getSpec = (prioirity) => post(url.GET_SPEC_PR, prioirity);
// get changes history for selected order
export const getHistory = (id) => get(url.GET_HISTORY + `/${id}`);
//USERS
export const getUsers = () => get(url.GET_USERS);
export const addUser = (user) => post(url.ADD_USER, user);
export const updateUser = (user) => put(url.UPDATE_USER + `/${user._id}`, user);
export const deleteUser = (user) => del(url.DELETE_USER + `/${user}`, user);
//DEPARTMENTS
export const getDepartments = () => get(url.GET_DEPARTMENTS);
export const addDepartment = (department) => post(url.ADD_DEPARTMENT, department);
export const updateDepartment = (department) => put(url.UPDATE_DEPARTMENT + `/${department._id}`, department);
export const deleteDepartment = (department) => del(url.DELETE_DEPARTMENT + `/${department}`, department);
//DOMAINS
export const getDomains = () => get(url.GET_DOMAINS);
export const addDomain = (domain) => post(url.ADD_DOMAIN, domain);
export const getCredentials = (domain) => post(url.GET_CREDENTIALS, domain);
export const updateDomain = (domain) => put(url.UPDATE_DOMAIN + `/${domain._id}`, domain);
export const deleteDomain = (domain) => del(url.DELETE_DOMAIN + `/${domain}`, domain);
//SUBSCRIPTIONS
export const getSubs = () => get(url.GET_SUBS);
export const addSub = (sub) => post(url.ADD_SUB, sub);
export const updateSub = (sub) => put(url.UPDATE_SUB + `/${sub._id}`, sub);
export const deleteSub = (sub) => del(url.DELETE_SUB + `/${sub}`, sub);
//CUSTOMER SERVICE
export const getCustomerService = () => get(url.GET_CUSTOMER_SERVICE);
export const addNewCustomerService = (custService) => post(url.ADD_NEW_CUSTOMER_SERVICE, custService);
export const updateCustomerService = (custService) => put(url.UPDATE_CUSTOMER_SERVICE + `/${custService._id}`, custService);
export const deleteCustomerService = (custService) => del(url.DELETE_CUSTOMER_SERVICE + `/${custService._id}`, custService);
//CALCULATOR
export const getMoscowData = () => get(url.GET_MOSCOW_DATA);
export const getShippingData = () => get(url.GET_SHIPPING_DATA);
export const addBoxSize = (box) => post(url.ADD_BOX_SIZE, box);
export const updateBoxSize = (box) => put(url.UPDATE_BOX_SIZE + `/${box._id}`, box);
export const deleteBoxSize = (box) => del(url.DELETE_BOX_SIZE + `/${box}`, box);
export const addPrice = (price) => post(url.ADD_PRICE, price);
export const updatePrice = (price) => put(url.UPDATE_PRICE + `/${price._id}`, price);
export const deletePrice = (price) => del(url.DELETE_PRICE + `/${price}`, price);
export const addTaxPrice = (tax_price) => post(url.ADD_TAX_PRICE, tax_price);
export const updateTaxPrice = (tax_price) => put(url.UPDATE_TAX_PRICE + `/${tax_price._id}`, tax_price);
export const deleteTaxPrice = (tax_price) => del(url.DELETE_TAX_PRICE + `/${tax_price}`, tax_price);
export const addCountryTr = (countries) => post(url.ADD_COUNTRIES_TR, countries);
export const addCountries = (countries) => post(url.ADD_COUNTRIES, countries);
//PRICE LIST
export const getPricesInfo = () => get(url.GET_PRICES_DATA);
export const addPriceProduct = (product) => post(url.ADD_PRICE_PRODUCT, product);
export const updatePriceProduct = (product) => put(url.UPDATE_PRICE_PRODUCT, product);
export const deletePriceProduct = (product) => del(url.DELETE_PRICE_PRODUCT + `/${product.id}|||${product.sortNo}|||${product.category}`, product);
export const updateResponsibleRegion = (person) => post(url.UPDATE_RESPONSIBLE_REGION, person);
export const getFont = (product) => post(url.GET_FONT, product);
//PRICE INFO
export const addInfoData = (data) => post(url.ADD_INFO_DATA, data);
export const updateInfoData = (data) => put(url.UPDATE_INFO_DATA + `/${data._id}`, data);
export const deleteInfoData = (data) => del(url.DELETE_INFO_DATA + `/${data.id}|||${data.type}|||${data.sortNo}`, data);
// export const getInfo = () => get(url.GET_INFO_DATA);

// export const getCatProductsInfo = (data) => put(url.GET_CAT_PRODUCTS_DATA + `/${data._id}`, data);
// export const getAccessInfo = () => get(url.GET_ACCESS_DATA);
// export const getProductsInfo = (data) => post(url.GET_PRODUCTS_DATA, data);
// export const getRegProductsInfo = (data) => post(url.GET_REG_PRODUCTS_DATA, data);

// export const getRegionInfo = (product) => post(url.GET_REGION_INFO, product);
// export const addProductsRegion = (product) => post(url.ADD_PRICE_DATA_REGION, product);

//MEETING
export const getMeetingsInfo = () => get(url.GET_MEETING_INFO);
export const addMeeting = (meeting) => post(url.ADD_MEETING, meeting);
export const updateMeeting = (meeting) => put(url.UPDATE_MEETING + `/${meeting._id}`, meeting);
export const deleteMeeting = (meeting) => del(url.DELETE_MEETING + `/${meeting}`, meeting);
//LOST ORDERS
export const getLostOrdersInfo = () => get(url.GET_LOST_ORDERS_INFO);
// export const addLostOrder = (order) => post(url.ADD_LOST_ORDER, order);
// export const updateLostOrder = (order) => put(url.UPDATE_LOST_ORDER + `/${order._id}`, order);
// export const deleteLostOrder = (order) => del(url.DELETE_LOST_ORDER + `/${order}`, order);
//ACTIVIDAN SHIPPING
export const getActShippingsInfo = () => get(url.GET_ACT_SHIPPING);
export const addActShipping = (act) => post(url.ADD_ACT_SHIPPING, act);
export const updateActShipping = (act) => put(url.UPDATE_ACT_SHIPPING + `/${act._id}`, act);
export const deleteActShipping = (act) => del(url.DELETE_ACT_SHIPPING + `/${act}`, act);
//STATS PAGE
export const getNewClients = () => get(url.GET_NEW_CLIENTS);
export const getSelectedNewClients = (new_clients) => post(url.GET_SELECTED_NEW_CLIENTS, new_clients);
// TRANSFERS
export const getTransfersInfo = () => get(url.GET_TRANSFERS_INFO);
export const getSpecTransfer = (transfer) => post(url.GET_STATUS_TRANSFER, transfer);
export const getCompletedTransfer = (transfer_completed) => post(url.GET_COMPLETED_TRANSFER, transfer_completed);
export const getFilteredTransferMoscow = (filtered_transfers_moscow) => post(url.GET_FILTERED_TRANSFERS_MOSCOW, filtered_transfers_moscow);
export const getAgentsInfo = () => get(url.GET_AGENTS_INFO);
export const addAgent = (agent) => post(url.ADD_AGENT, agent);
export const updateAgent = (agent) => put(url.UPDATE_AGENT + `/${agent._id}`, agent);
export const deleteAgent = (agent) => del(url.DELETE_AGENT + `/${agent}`, agent);
//TRANSFERS MOSCOW
export const getTransfersMoscow = () => get(url.GET_TRANSFERS_MOSCOW);
export const getTransfersMoscowList = () => get(url.GET_TRANSFERS_MOSCOW_LIST);
export const addTransferMoscow = (tr_moscow) => post(url.ADD_TRANSFER_MOSCOW, tr_moscow);
export const updateTransferMoscow = (tr_moscow) => put(url.UPDATE_TRANSFER_MOSCOW + `/${tr_moscow._id}`, tr_moscow);
export const deleteTransferMoscow = (tr_moscow) => del(url.DELETE_TRANSFER_MOSCOW + `/${tr_moscow}`, tr_moscow);
//TRANSFERS PRIORITY
export const getTransfersPriority = () => get(url.GET_TRANSFERS_PRIORITY);
export const addTransferPriority = (tr_priority) => post(url.ADD_TRANSFER_PRIORITY, tr_priority);
export const updateTransferPriority = (tr_priority) => put(url.UPDATE_TRANSFER_PRIORITY + `/${tr_priority._id}`, tr_priority);
export const deleteTransferPriority = (tr_priority) => del(url.DELETE_TRANSFER_PRIORITY + `/${tr_priority}`, tr_priority);

export const getTransfersShipping = () => get(url.GET_TRANSFERS_SHIPPING);
export const updateTransferMoscowData = (tr_moscow_data) => post(url.UPDATE_TRANSFER_MOSCOW_DATA, tr_moscow_data);
export const deleteTransferShipping = (tr_shipping) => del(url.DELETE_TRANSFER_SHIPPING + `/${tr_shipping}`, tr_shipping);
//PURCHASES PAGE
export const addProduct = (product) => post(url.ADD_PRODUCT, product);
export const updateProduct = (product) => put(url.UPDATE_PRODUCT + `/${product._id}`, product);
export const deleteProduct = (product) => del(url.DELETE_PRODUCT + `/${product}`, product);

export const getPurchasesInfo = () => get(url.GET_PURCHASES_INFO);
export const addPurchase = (purchase) => post(url.ADD_PURCHASE, purchase);
export const updatePurchase = (purchase) => put(url.UPDATE_PURCHASE + `/${purchase._id}`, purchase);
export const deletePurchase = (purchase) => put(url.DELETE_PURCHASE + `/${purchase._id}`, purchase);

export const getArrivedPurchases = (purchases) => post(url.GET_ARRIVED_PURCHASES, purchases);
export const getArrivedProducts = (products) => post(url.GET_ARRIVED_PRODUCTS, products);

export { getLoggedInUser, isUserAuthenticated, postLogin, postJwtForgetPwd, postJwtResetPwd };
